import { ArrowLeft } from '@griply/assets';
import React from 'react';
import {
  Colors as IconButtonColors,
  IconButton,
} from 'shared/components/ui/icon-button';

import * as Styled from './side-navigation-panel.style';

export type SideNavigationPanelProps = {
  backLabel: string;
  onBack: () => void;
  children: React.ReactNode;
};

export const SideNavigationPanel: React.FC<SideNavigationPanelProps> = ({
  backLabel,
  onBack,
  children,
}) => (
  <Styled.Container>
    <Styled.Header>
      <IconButton
        icon={ArrowLeft}
        onClick={onBack}
        aria-label={backLabel}
        color={IconButtonColors.Default}
      />
    </Styled.Header>

    <Styled.Sections>{children}</Styled.Sections>
  </Styled.Container>
);
